import { isValidCardNumber } from "./cardNumberValidator";
import { isValidExpiryDate } from "./expiryDateValidator";
import { isCvvValid } from "./cvvValidator";
import { getCardTypeByValue } from "./card-types-selector";
export var PaymentInputValidation = function (values, options) {
    var errors = {};
    var bypassLuhnValidation = (options === null || options === void 0 ? void 0 : options.bypassLuhnValidation) === true &&
        (options.environment === "localhost" || (options === null || options === void 0 ? void 0 : options.environment) === "dev" || (options === null || options === void 0 ? void 0 : options.environment) === "stage");
    var resultCard = isValidCardNumber(values.cardNumber, bypassLuhnValidation);
    if (!resultCard.valid) {
        errors.cardNumber = resultCard.error;
    }
    var resultExpiryDate = isValidExpiryDate(values.expiryDate);
    if (!resultExpiryDate.valid) {
        errors.expiryDate = resultExpiryDate.error;
    }
    var rawCardNumber = values.cardNumber.replace(/\s/g, '');
    var cardType = getCardTypeByValue(rawCardNumber);
    var result = isCvvValid(values.cvc, cardType);
    if (!result.valid) {
        errors.cvc = result.error;
    }
    return errors;
};
